import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import IPCRFormPresenter from "./IPCRFormPresenter";
import CardView from "../../../../components/common/CardView";
// import FileUpload from "../../../../components/common/FileUpload";
// import { Button, dialog } from "nq-component";
import InputRow from "../../my-component/InputRow";
import PerformanceTable from "../../my-component/PerformanceTable";
import { DatePicker, Space } from "antd";
import InputFactory from "../../../../components/InputFactory";
import dayjs from "dayjs";

class IPCRForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      periodFrom: "",
      periodTo: "",
      addRow: false,
      output: "",
      successindicators: "",
      actualaccomplishments: "",
      distribution: "",
      quality: "",
      efficiency: "",
      timeliness: "",
      remarks: "",
      ipcrForm: [],
      isRating: false,
      object: {},
      indexToEdit: null,
      searchTerm: "",
      rating: ["Quality", "Efficiency", "Timeliness"],
      inputField: [
        "Output",
        "Success Indicators",
        "Actual Accomplishments",
        "Distribution",
      ],
      assignedEmployee: {},
      findEmp: [],
      primaryObject: {},
      where: {},
      whereReady: false,
    };
    this.presenter = new IPCRFormPresenter(
      this,
      findObjectUseCase(),
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  handleRatingClick() {
    this.setState((prevState) => ({ isRating: !prevState.isRating }));
  }

  getCollectionName() {
    return "ipcr";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const params = this.getParams()?.id || "";
    const primaryObject = this.state;
    const update = primaryObject;
    const objectArray = Array.isArray(update.object)
      ? update.object
      : [update.object];
    const filteredObject = objectArray.filter((item) => item.id === params);
    console.log("qq:", filteredObject);

    const query = {
      where: {
        id: params,
      },
      include: ["all"],
    };
    const find = await findObjectUseCase().execute("ipcr", query);

    this.setState({ findEmp: find });

    console.log("findsss", find);
  }

  componentDidUpdate(prevProps, prevState) {
    const { object, indexToEdit, ipcrForm } = this.state;
    if (prevState.object !== object && indexToEdit !== null) {
      const getObject = ipcrForm[indexToEdit];
      if (getObject) {
        this.setState({
          ...getObject,
          // output: getObject.output,
          // successindicators: getObject.successindicators,
          // actualaccomplishments: getObject.actualaccomplishments,
          // distribution: getObject.distribution,
          // quality: getObject.quality,
          // efficiency: getObject.efficiency,
          // timeliness: getObject.timeliness,
          // remarks: getObject.remarks,
        });
      }
    }

    if (prevState.object !== this.state.object) {
      if (this.state.object.length > 0) {
        const object = this?.state?.object?.find(
          (item) => item.id === this.getObjectId()
        );
        console.log("asdlkfjasdlfis; ", object);
        this.setState({
          ipcrForm: object.performance,
          // selectedFiles: object.selectedFiles,
          // modifyFiles: object.modifyFiles,
          // periodFrom: object.periodFrom,
          // periodTo: object.periodTo,
          ...object,
        });
      }
    }
  }

  handleCloseRow() {
    this.setState({ addRow: false });
  }

  handleChange(field, value) {
    // console.log("FFFF", { [field]: value });
    // if (field === "distribution") {
    //   value = `${value}%`;
    // }
    this.setState({ [field]: value });
  }

  handleRatingChange(field, value) {
    const regex = /^(\d{0,1}(\.\d{0,2})?)?$/;
    if (!regex.test(value)) {
      value = "";
    } else if (parseFloat(value) > 5) {
      value = "5";
    }
    this.setState({ [field]: value });
  }

  handleRemarksChange(remarks) {
    this.setState({ remarks });
  }

  handleTrashData(indexToRemove) {
    const removedItem = this.state.ipcrForm.filter(
      (_, index) => index !== indexToRemove
    );
    this.setState({ ipcrForm: removedItem });
  }

  handleEditData(object, indexToEdit) {
    this.setState({
      object,
      indexToEdit,
      addRow: true,
      output: object.output,
      successindicators: object.successindicators,
      actualaccomplishments: object.actualaccomplishments,
      distribution: object.distribution,
      quality: object.quality,
      efficiency: object.efficiency,
      timeliness: object.timeliness,
      remarks: object.remarks,
    });
  }

  handleSearch(event) {
    this.setState({ searchTerm: event.target.value });
  }

  // changeFile
  handleFileChange(selectedFiles) {
    this.setState({ selectedFiles });
  }

  handleFileChange2(modifyFiles) {
    this.setState({ modifyFiles });
  }

  onChange(value, field) {
    console.log({ [field]: value });
    this.setState({ [field]: value });
    // this.presenter.onChange(value, field);
  }

  setWhere(where) {
    this.setState({ where, whereReady: true });
  }

  render() {
    const primaryObject = this.state;
    const isMobile = window.innerWidth <= 768;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    const params = this.getParams().id;
    const update = primaryObject;

    const objectArray = Array.isArray(update.object)
      ? update.object
      : [update.object];
    const filteredObject = objectArray.filter((item) => item.id === params);

    // const getAssigned = this.getAssigned(filteredObject);

    // console.log("geteget", getAssigned);

    if (!schema) return <h1>No schema</h1>;

    const filteredIpcrForm = primaryObject.ipcrForm.filter((item) =>
      Object.values(item).some((val) =>
        val
          .toString()
          .toLowerCase()
          .includes(primaryObject.searchTerm.toLowerCase())
      )
    );

    const fields = [
      ...primaryObject.inputField,
      ...primaryObject.rating,
      "average",
      "averagedeci",
      "remarks",
    ].map((field) => field.replace(" ", "").toLowerCase());
    const { RangePicker } = DatePicker;
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className={`h-100 ${isMobile ? "p-1" : "p-2 m-4"}`}>
            <CardView style={{ borderRadius: 0, padding: 0 }}>
              <div>
                <h6 className="ps-4 pt-4">
                  <b>INDIVIDUAL PERFORMANCE COMMITMENT AND REVIEW (IPCR)</b>
                </h6>
                <hr />
              </div>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.presenter.handleFormSubmit();
                }}
                className="p-3"
              >
                <div>
                  <label>
                    Period <span className="text-danger">*</span>
                  </label>
                  <br />
                  <Space direction="vertical" size={20}>
                    <RangePicker
                      required
                      value={
                        this.state.periodFrom && this.state.periodTo
                          ? [
                              dayjs(this.state.periodFrom),
                              dayjs(this.state.periodTo),
                            ]
                          : null
                      }
                      onChange={(date, value) =>
                        this.setState({
                          periodFrom: value[0],
                          periodTo: value[1],
                        })
                      }
                      className="custom-range-picker border p-2 fw-semibold"
                    />
                  </Space>
                  <div className="mt-2">
                    <label>
                      Employee <span className="text-danger">*</span>
                    </label>
                    {this.state.whereReady ? (
                      <InputFactory
                        key={JSON.stringify(this.state.where)}
                        type="Pointer"
                        required
                        defaultValue={this.state.findEmp[0]?.assignedEmployee}
                        field="assignedEmployee"
                        target="employees"
                        where={this.state.where}
                        onChange={this.onChange.bind(this)}
                        placeholder="Select Employee"
                      />
                    ) : (
                      <div className="text-muted fs-sm py-2">
                        Loading employee list...
                      </div>
                    )}
                  </div>

                  <div className="border mt-4 p-0">
                    <div className="row pt-2 ps-2 pe-2 pb-0 m-0">
                      <div className="col-lg-6 d-grid">
                        {[5, 4, 3, 2, 1].map((score, index) => (
                          <span key={index}>
                            {score} -{" "}
                            {
                              [
                                "Outstanding",
                                "Very Satisfactory",
                                "Satisfactory",
                                "Unsatisfactory",
                                "Poor",
                              ][index]
                            }
                          </span>
                        ))}
                      </div>
                      <div className="col-lg-6 d-flex align-items-end gap-3">
                        <input
                          type="search"
                          className="form-control rounded ps-5"
                          placeholder="Search"
                          onChange={this.handleSearch.bind(this)}
                        />
                        <button
                          type="button"
                          className="btn btn-primary w-25"
                          onClick={() => this.presenter.handleAddRow()}
                        >
                          <i className="bi bi-plus-lg" /> {schema.collection}
                        </button>
                      </div>
                      {/* <div className="pt-1 ps-1 pe-1 pb-0"> */}
                      <PerformanceTable
                        tableHeader={[
                          "#",
                          "Major Final Output",
                          "(Targets + Measures)",
                          "Actual Accomplishments",
                          "%Distribution",
                          "Q1",
                          "E2",
                          "T3",
                          "A4",
                          "Ave",
                          "Remarks",
                          "Actions",
                        ]}
                        // formulaHeader={[
                        //   "",
                        //   "",
                        //   "",
                        //   "",
                        //   "(g)",
                        //   "(h)",
                        //   "(i)",
                        //   "(j)",
                        //   "(k = ave of h, i, j)",
                        //   "(l = g x k)",
                        //   "(m)",
                        //   "",
                        // ]}
                        tableBody={fields}
                        object={filteredIpcrForm}
                        handleRatingClick={this.handleRatingClick.bind(this)}
                        isRating={this.state.isRating}
                        handleTrashData={this.handleTrashData.bind(this)}
                        handleEditData={this.handleEditData.bind(this)}
                      />
                      {/* </div> */}
                      {/* final Rating  */}
                      <div className="border row m-auto mb-2">
                        {filteredIpcrForm && (
                          <>
                            <div className="text-end">
                              <label
                                style={{
                                  padding: "5px",
                                  wordWrap: "break-word",
                                  textAlign: "center",
                                }}
                                colSpan={7}
                              >
                                <b>FINAL AVERAGE RATING</b>
                              </label>
                              <label
                                style={{
                                  padding: "5px",
                                  wordWrap: "break-word",
                                  textAlign: "center",
                                }}
                                colSpan={3}
                              >
                                {filteredIpcrForm
                                  .reduce(
                                    (sum, item) =>
                                      sum + parseFloat(item.averagedeci),
                                    0
                                  )
                                  .toFixed(2)}
                              </label>
                            </div>
                            <div className="col-lg-6 fs-6">
                              {/* <div>
                                <label
                                  style={{
                                    padding: "5px",
                                    wordWrap: "break-word",
                                    textAlign: "center",
                                  }}
                                  colSpan={7}
                                >
                                  <b>TOTAL RATING</b>
                                </label>
                                <label
                                  style={{
                                    padding: "5px",
                                    wordWrap: "break-word",
                                    textAlign: "center",
                                  }}
                                  colSpan={3}
                                >
                                  {filteredIpcrForm
                                    .reduce(
                                      (sum, item) =>
                                        sum + parseFloat(item.averagedeci),
                                      0
                                    )
                                    .toFixed(2)}
                                </label>
                              </div> */}
                              <label className="fw-bold ps-2">
                                Assessed by:
                              </label>
                              <div className="p-2">
                                <label className="form-label fs-sm">
                                  Name <span className="text-danger">*</span>
                                </label>
                                <InputFactory
                                  type="String"
                                  field="headName"
                                  defaultValue={this.state.headName}
                                  onChange={this.onChange.bind(this)}
                                  className="form-control"
                                  required
                                />
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <label className="fw-bold"></label>
                              <div className="p-2">
                                <label className="form-label fs-sm">
                                  Position{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <InputFactory
                                  type="String"
                                  defaultValue={this.state.headPosition}
                                  field="headPosition"
                                  onChange={this.onChange.bind(this)}
                                  className="form-control"
                                  required
                                />
                              </div>

                              {/* second */}
                            </div>
                            <div className="col-lg-6 fs-6">
                              <label className="fw-bold ps-2">
                                Final Rating by:
                              </label>
                              <div className="p-2">
                                <label className="form-label fs-sm">
                                  Name <span className="text-danger">*</span>
                                </label>
                                <InputFactory
                                  type="String"
                                  field="finalName"
                                  defaultValue={this.state.finalName}
                                  onChange={this.onChange.bind(this)}
                                  className="form-control"
                                  required
                                />
                              </div>
                            </div>
                            <div className="col-lg-6 fs-6">
                              <label className="fw-bold ps-2"></label>
                              <div className="p-2">
                                <label className="form-label fs-sm">
                                  Position{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <InputFactory
                                  type="String"
                                  field="finalPosition"
                                  defaultValue={this.state.finalPosition}
                                  onChange={this.onChange.bind(this)}
                                  className="form-control"
                                  required
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row d-flex align-items-center p-3">
                    <div
                      className="col-lg-1 border"
                      style={{ height: "1px" }}
                    />
                    <span className="col-lg-2 text-center">
                      <i className="bi bi-file-earmark" /> Attachments
                    </span>
                    <div
                      className="col-lg-9 border"
                      style={{ height: "1px" }}
                    />

                    <div className="col-lg-12 mt-5">
                      <InputFactory
                        type="File"
                        onChange={this.handleFileChange.bind(this)}
                        value={this.state.selectedFiles}
                        className="form-control"
                      />
                    </div>
                    {filteredObject[0]?.stats === "Pending" && (
                      <div className="col-lg-12 mt-5">
                        <InputFactory
                          type="File"
                          onChange={this.handleFileChange2.bind(this)}
                          value={this.state.modifyFiles}
                          className="form-control"
                        />
                      </div>
                    )}
                  </div>
                </div>
                <hr />
                <div className="mb-4 ms-auto pe-4">
                  <button
                    type="button"
                    className="btn btn-light fs-sm me-3"
                    onClick={this.onClickBack.bind(this)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-primary fs-sm" type="submit">
                    <i className="bi bi-file-earmark-check me-2"></i>
                    {label}
                  </button>
                </div>
              </form>
            </CardView>
          </div>
        </div>

        {primaryObject.addRow && (
          <InputRow
            ratings={primaryObject.rating}
            inputField={primaryObject.inputField}
            handleRatingClick={this.handleRatingClick.bind(this)}
            handleAddData={() => this.presenter.handleAddData()}
            handleCloseRow={this.handleCloseRow.bind(this)}
            handleRemarksChange={this.handleRemarksChange.bind(this)}
            handleChange={this.handleChange.bind(this)}
            handleRatingChange={this.handleRatingChange.bind(this)}
            primaryObject={primaryObject}
          />
        )}
      </>
    );
  }
}

export default withRouter(IPCRForm);
